/* globals BigInt */

import React, { useState, useEffect } from 'react'
import { maxPrimes } from './constants';
import { isValidN } from './functions/validN';

let controller = new AbortController();

export default ({ z, count, setResults }) => {
  const [enabled, setEnabled] = useState(isValidN(z || "0"))

  useEffect(() => { setEnabled(isValidN(z || "0")) }, [z])

  const start = async (z) => {
    let resultCount = 0
    setEnabled(false)
    setResults([])
    const site = "/.netlify/functions/primes"

    let url = `${site}?z=${z}`;

    const handleResult = (prevState, data) => {
      const newState = prevState.concat(data)
      resultCount = newState.length
      return newState;
    }

    do {
      let data;

      try {
        const response = await fetch(url);
        if (response.ok) {
          data = await response.json();
          setResults((prevState) => handleResult(prevState, data))
        } else {
          throw response;
        }

      } catch (err) {
        const msg = await err.text()
        const status = err.status + " " + err.statusText
        alert(msg + "\n(" + status + ")")
        break;
      }

      let N = BigInt(data.N)
      let func = data.func

      url = `${site}?z=${N}&inFunc=${func}`;

    } while (resultCount < Math.min(count, maxPrimes) && !controller.signal.aborted)

    setEnabled(true)
    controller = new AbortController()
  }

  const stop = () => controller.abort();

  return <div className="row" >
    <div className="column">
      <input type="button" value="Submit" disabled={!enabled} onClick={() => start(z)}></input>
    </div>

    <div className="column">
      <input type="button" value="Stop" disabled={enabled} onClick={() => stop()}></input>
    </div>

  </div>
}